import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";

export interface PageProps {
  sidebar?: boolean;
}

export interface MainProps {
  sidebar?: boolean;
}

export interface BreadcrumbProps {
  items?: (string | [string, string])[];
}

class Layout {

  static FullPage: React.FC<PageProps> = ({ children }) => (
    <div className="flex-grow-1 d-flex flex-column o-main-background scroll-auto custom-scrollbar">
      {children}
    </div>
  );

  static SidebarPage: React.FC<PageProps> = ({ children }) => (
    <div className="flex-grow-1 d-flex flex-column o-main-background scroll-auto custom-scrollbar flex-xl-row">
      {children}
    </div>
  );

  static Main: React.FC<MainProps> = ({ children }) => (
    <div className="d-flex flex-column flex-xl-grow-1 scroll-xl-auto custom-scrollbar">
      {children}
    </div>
  );

  static Sidebar: React.FC = ({ children }) => (
    <div className="c-sidebar bg-panel-dark scroll-xl-auto custom-scrollbar">
      {children}
    </div>
  );

  static Header: React.FC = ({ children }) => (
    <div className="mx-2 my-3">
      <Container fluid>
        {children}
      </Container>
    </div>
  );

  static Body: React.FC = ({ children }) => (
    <div className="mx-2 mb-3">
      <Container fluid>
        {children}
      </Container>
    </div>
  );

  static Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => (
    <div>
      {!!items
        ? (
          <ul className="list-none text-uppercase d-inline">
            {items.map((x, i) => (
              <li key={i} className="d-inline">
                {typeof x === "string"
                  ? x
                  : (
                    <Link to={x[1]}>
                      {x[0]}
                    </Link>)}
                &nbsp;/&nbsp;
              </li>
            ))}
          </ul>)
        : (<>&nbsp;</>)}
    </div>
  );

  static Title: React.FC = ({ children }) => (
    <h1 className="mb-0">{children}</h1>
  );
}

export default Layout;
